/// <amd-module name="SearchUI/PathSelector" />
export * from "SearchUI/Components/PathSelector/index";
